import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Report, RowActions } from 'src/app/dashboard/admin/report/report';
import { LanguageService } from 'src/app/shared/services/language.service';
import { TransactionsDetailReportService } from '../../services/transaction-detail-report.service';

@Component({
  selector: 'app-transactions-detail',
  templateUrl: './transactions-detail.component.html',
  styleUrls: ['./transactions-detail.component.scss'],
})
export class TransactionsDetailComponent implements OnInit {
  tableColumns: string[] = ['refNumber', 'fees', 'VAT', 'gross_amount'];
  rowActions: RowActions[] = [];
  displayTableColumns: object = {};
  oldTickets: object = {};
  curuntTicket: any[] = [];
  reportName = '';
  totalNumberOfRecords: number = 0;
  reportData: any[] = [];
  filterField: any[] = [];

  requestBody: Report = {};
  loading = false;

  constructor(
    public transactionsDetailService: TransactionsDetailReportService,
    private translate: TranslateService,
    private languageService: LanguageService,
  ) {}

  async ngOnInit() {
    if (localStorage.getItem('language')) {
      if (localStorage.getItem('language') === 'ar') {
        this.loadArContent();
      } else if (localStorage.getItem('language') === 'en') {
        this.loadEnContent();
      }
    } else {
      this.loadEnContent();
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      if (lang === 'ar') {
        this.loadArContent();
      } else if (lang === 'en') {
        this.loadEnContent();
      }
    });
    this.transactionsDetailService.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    await this.updateTable();
  }

  loadArContent() {
    this.translate.use('ar');
    this.reportName = 'تقرير تفصيلي للمعاملات';
    this.displayTableColumns = {
      refNumber: 'رقم المرجع',
      fees: 'الرسوم',
      VAT: 'ضريبة القيمة المضافة',
      gross_amount: 'المبلغ الإجمالي',
    };
  }

  loadEnContent() {
    this.translate.use('en');
    this.reportName = 'Transactions Detail Report';
    this.displayTableColumns = {
      refNumber: 'Reference Number',
      fees: 'Fees',
      VAT: 'VAT',
      gross_amount: 'Gross Amount',
    };
  }

  actionsCB(_: any) {}

  async filter($event: any) {
    if ($event && Object.keys($event).length) {
      this.requestBody.filterOptions = $event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    await this.updateTable();
    this.transactionsDetailService
      .loader()
      .subscribe((val: any) => (this.loading = val));
  }

  async paginate($event: any) {
    this.requestBody.paginationOptions = {
      start: $event.pageIndex * $event.pageSize,
      limit: $event.pageSize,
    };
    await this.updateTable();
    this.transactionsDetailService
      .loader()
      .subscribe((val: any) => (this.loading = val));
  }

  async searchChange($event: any) {
    if ($event) {
      this.requestBody.searchOptions = {
        searchKey: $event,
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.transactionsDetailService
        .loader()
        .subscribe((val: any) => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction,
      };
    }
    await this.updateTable();
    this.transactionsDetailService
      .loader()
      .subscribe((val: any) => (this.loading = val));
  }

  async updateTable() {
    if (
      this.requestBody['filterOptions'] &&
      this.requestBody['filterOptions']['createdAt']
    ) {
      const { startDate, endDate } = this.requestBody['filterOptions'][
        'createdAt'
      ] as any;
      this.requestBody.filterOptions.createdAt.from =
        this.formatDate(startDate) + ' 00:00:00';
      this.requestBody.filterOptions.createdAt.to =
        this.formatDate(endDate) + ' 23:59:59';
    }
    this.transactionsDetailService.activateLoader();
    this.transactionsDetailService.setParams(this.requestBody);
    const report = await this.transactionsDetailService.make();
    this.reportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  private formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    const m = date.getMonth() + 1; // months are 0 indexed

    const month = ('0' + m).slice(-2); // add a 0 padding
    const year = date.getFullYear();
    const day = ('0' + date.getDate()).slice(-2); // add a 0 padding
    return `${year}-${month}-${day}`;
  }
}
